define.alias("ember-math-helpers/helpers/clz32", "settings/helpers/clz32");